import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
} from '../../../route';

// Legacy enhanced draft page, moved here from /sales-orders/draft/... when
// OMS v3 took over the unversioned path. The component intentionally stays in
// ../../../sales-orders/$salesOrderDraftId/ (folder not renamed to avoid
// churn).
const EnhancedSalesOrderDraftPage = lazyRouteComponent(
  () =>
    import('../../../sales-orders/$salesOrderDraftId/EnhancedSalesOrderDraftPage'),
  'EnhancedSalesOrderDraftPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/sales-orders-v2/draft/$salesOrderDraftId',
  staticData: {
    app: {
      access: {
        modulesAnyOf: [ProductModule.ORDER_MANAGEMENT],
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.SalesOrderDraft },
        ],
      },
    },
  },
  component: EnhancedSalesOrderDraftPage,
  loader: () => ({
    crumb: 'Sales Order Draft',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDER_MANAGEMENT],
    });
  },
});
